import React from "react";
import DownloadPdfButton from "./Download/DownloadPdfButton";
import FeedbackButton from "./FeedbackButton";
import NavCloseButton from "./NavCloseButton";
import UserDropMenu from "./UserDropMenu";
import MobileMenu from "./MobileMenu";

export default function NavRightSection() {

    return (
        <>
            <DownloadPdfButton />
            <FeedbackButton />
            <MobileMenu />
            <NavCloseButton />
            <UserDropMenu />
        </>
    )
}